module.exports = "<p>{{coptyRight}}<a class=\"default\" target=\"_blank\" href=\"https://beian.miit.gov.cn\">{{coptyRecord}}</a><span v-if=\"support\" class=\"support_box\">{{support}}</span></p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/footer/footer-component.tpl
// module id = TePW
// module chunks = 1